import { TranslateRange } from './types';

export const calculateCurrentX = (touches: TouchList) => {
  return touches[0].pageX;
};

export const calculateCurrentY = (touches: TouchList, containerWindow: Window) => {
  return containerWindow.innerHeight - touches[0].clientY;
};

export const getTranslate = ({
  currentX,
  startLocation,
  translateRange,
  baseTranslate,
}: {
  currentX: number;
  startLocation: number;
  translateRange: TranslateRange;
  baseTranslate: number;
}) => {
  return Math.max(Math.min(baseTranslate + currentX - startLocation, translateRange.max), translateRange.min);
};
